import { assign, every, filter, find, forEach, map, orderBy } from 'lodash';
import React from 'react';
import componentServices from '../componentServices';
import * as actions from '../actions';
import * as reportActions from '../reportActions';import globalRelay from '../globalRelay';
import JobCostSummary from '../models/jobCostSummary';
import { Alert, AsyncButton } from './sharedComponents';
import { getCollection, ModelCollection } from 'Scripts/store';

const CombinedContractRow = class Row extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange (e) {
		const { setEstimateState } = this.props;
		const checked = e.target.checked;

		setEstimateState(checked);
	}

	render () {
		const { estimate } = this.props;
		const globalConfig = globalRelay.config!.withVariant(estimate.companyVariant);
		const totalSell = isNaN(estimate.totalSell) ? 0 : estimate.totalSell;
		const sellDisplay = '$' + (totalSell < 1000 ? totalSell.toFixed(0) : ((totalSell / 1000).toFixed(1) + 'K'));
		const numberRow = globalRelay.config!.variants.length > 1 && globalConfig.badge ? <td className="jobNumber">{estimate.relayNumber} <span className="badge" style={{ backgroundColor: globalConfig.badge.color }}><span>{ globalConfig.badge.label }</span></span></td> : <td className="jobNumber">{estimate.relayNumber}</td>;

		return (<tr className={ !estimate.canBeSelected ? 'disabled' : ''}>
			<td />
			<td><label><input type="checkbox" onChange={ this.handleChange } checked={ estimate.isSelected } />{ estimate.name }</label></td>
			<td>{ estimate.statusLabel }</td>
			<td className="sell" style={ { paddingRight: '40px' } }>{ sellDisplay }</td>
			{ numberRow }
			<td />
		</tr>);
	}
};

export default class PrintCombinedContract extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = { allSelected: false, estimates: [], reportOption: 'combined-single-summary' };

		this.handleSelectAllChanged = this.handleSelectAllChanged.bind(this);
		this.setReportOption = this.setReportOption.bind(this);
		this.printContract = this.printContract.bind(this);
	}

	UNSAFE_componentWillReceiveProps (nextProps) {
		this.setState(this.getStateFromProps(nextProps));
	}

	getStateFromProps (props) {
		const { job } = props;
		const { store } = componentServices;
		const jobCosts = getCollection({ store, collection: ModelCollection.jobCosts });
		const state = assign({}, this.state);
		const existingEstimates = state.estimates;
		const estimates:any[] = [];

		if (jobCosts && jobCosts.count()) {
			jobCosts
				.filter(jc => {
					return jc.jobKey === job.key && !jc.isContract;
				})
				.forEach(jc => {
					const existingEstimate = find(existingEstimates, { key: jc.key });
					const summary = new JobCostSummary(jc, job.getAppliedPaymentTotal(jc.key));
					const result = jc.toDocument();

					summary.buildItems();
					result.totalSell = summary.grandTotalSell;
					result.canBeSelected = jc.currentStatus === 'locked';
					result.statusLabel = result.canBeSelected ? 'Finalized' : 'Draft';
					result.relayNumber = jc.relayNumber;
					result.summary = summary;
					result.isSelected = existingEstimate && existingEstimate.isSelected || false;
					result.companyVariant = jc.companyVariant;

					estimates.push(result);
				});
		}

		state.estimates = orderBy(estimates, ['canBeSelected', 'name'], ['desc', 'asc']);

		return state;
	}

	handleSelectAllChanged () {
		this.setState(previousState => {
			const newState = assign({}, previousState);
			const selectable = filter(newState.estimates, { canBeSelected: true });
			const allSelected = every(selectable, { isSelected: true });

			forEach(selectable, estimate => {
				estimate.isSelected = !allSelected;
			});

			newState.allSelected = every(selectable, { isSelected: true });

			return newState;
		});
	}

	printContract () {
		const { job } = this.props;
		const { estimates, reportOption } = this.state;
		const selectedEstimates = filter(estimates, { isSelected: true });
		let baseTerms;
		let variant;
		let termsMatch = true;
		let variantsMatch = true;

		forEach(selectedEstimates, estimate => {
			if (termsMatch) {
				const terms = orderBy(estimate.paymentTerms, ['sortIndex'], ['asc']);

				if (!baseTerms) {
					baseTerms = terms;
				}
				else {
					termsMatch = terms.length === baseTerms.length;

					if (termsMatch) {
						for (let i = 0; i < baseTerms.length; i++) {
							if (baseTerms[i].description !== terms[i].description) {
								termsMatch = false;
								break;
							}
						}
					}
				}
			}

			if (variantsMatch) {
				if (!variant) {
					variant = estimate.companyVariant;
				}

				variantsMatch = estimate.companyVariant === variant;
			}
		});

		let result = Promise.resolve();

		if (!termsMatch || !variantsMatch) {
			actions.pushAlert({ type: 'error', message: 'Invalid Selection\nAll estimates must have the same number of terms with identical descriptions and must belong to the same variant.', isCloseable: true });
		}
		else if (selectedEstimates.length < 2) {
			actions.pushAlert({ type: 'error', message: 'You must select at least 2 estimates', isCloseable: true });
		}
		else {
			const summaries = map(selectedEstimates, estimate => estimate.summary);

			result = reportActions.fetchReport({ summaries: summaries, job: job, report: `contract/${reportOption}` });
		}

		return result;
	}

	setReportOption (e) {
		const option = e.target.value;

		this.setState(previousState => {
			const newState = assign({}, previousState);

			newState.reportOption = option;

			return newState;
		});
	}

	setEstimateState (estimate, selected) {
		this.setState(previousState => {
			const newState = assign({}, previousState);

			estimate.isSelected = selected;

			newState.allSelected = every(filter(newState.estimates, { canBeSelected: true }), { isSelected: true });

			return newState;
		});
	}

	render () {
		const { close } = this.props;
		const { allSelected, estimates, reportOption } = this.state;
		const alerts:JSX.Element[] = [];

		const rows = map(estimates, estimate => {
			return <CombinedContractRow key={ estimate.key } estimate={ estimate } setEstimateState={ this.setEstimateState.bind(this, estimate) } />;
		});

		// TODO: move this to the generic modal component if possible
		componentServices.store.getIn(['viewState', 'alerts']).forEach(function (def) {
			alerts.push(<Alert type={def.type} message={def.message} isCloseable={def.isCloseable} clear={def.clear} key={def.key} />);
		});

		const alertContainer = alerts.length === 0 ? null : (<div className="alerts">{ alerts }</div>);

		return (<div className="window">
			<header>
				<button className="cancel" onClick={ close }><span>Cancel</span></button>
				<span>Print Combined Contract</span>
				<AsyncButton className="action save" asyncAction={ this.printContract } label="Print" />
			</header>
			{ alertContainer }
			<div className="views">
				<div className="content in scrollable">
					<section>
						<header><span className="centered">Select Any Finalized Estimates</span></header>
						<div className="inner">
							<table className="centered" cellPadding="0" cellSpacing="0">
								<thead>
									<tr>
										<td />
										<td><label><input type="checkbox" onChange={ this.handleSelectAllChanged } checked={ allSelected } />Estimate Name</label></td>
										<td>Status</td>
										<td className="sell" style={ { paddingRight: '40px' } }>Sell</td>
										<td className="jobNumber">Relay No.</td>
										<td />
									</tr>
								</thead>
								<tbody>
									{ rows }
								</tbody>
							</table>
						</div>

						<section>
							<header><span className="centered">Select a Summary Page Printing Option</span></header>
							<div className="inner">
								<table className="centered" cellPadding="0" cellSpacing="0">
									<tbody>
										<tr>
											<td />
											<td>
												<label><input type="radio" name="report" value="combined-single-summary" onClick={ this.setReportOption } checked={ reportOption === 'combined-single-summary' } /><span>Print a combined Summary page</span></label>
												<label><input type="radio" name="report" value="combined" onClick={ this.setReportOption } checked={ reportOption === 'combined' } /><span>Print separate Summary pages</span></label>
											</td>
											<td />
										</tr>
									</tbody>
								</table>
							</div>
						</section>

					</section>
				</div>
			</div>
		</div>);
	}
}